// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__8TBsn","title":"AfterBackImages_title__1ALlo","images":"AfterBackImages_images__1z2eJ"};